<template>
  <div>
    <v-navigation-drawer
      v-model="drawer"
      app
    >
      <v-list dense>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          @click="to(item.path)"
        >
          <v-list-item-content>
            <v-list-item-title>
              <v-icon>{{ item.icon }}</v-icon>
              {{ item.title }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar
      color="primary"
      dark
      fixed
      app
    >
      <v-app-bar-nav-icon @click="drawer = !drawer"/>
      <v-toolbar-title>
        Prosense MyPage
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        class="ma-2"
        outlined
        @click="logout()"
      >
        ログアウト
      </v-btn>
    </v-app-bar>
  </div>
</template>

<script>
import { app } from '@/core/firebase.js'

export default {
  name: 'TeacherLoggedInAppToolBar',
  data() {
    return {
      drawer: false,
      teacher: this.$store.getters.teacher,
      items: [
        { title: 'オンラインエディタ', path: '/editors'}
      ]
    }
  },

  methods: {
    to(path) {
      this.$router.push('/teacher/' + this.teacher.uuid + path)
    },
    async logout() {
      await app.auth().signOut()
      this.$store.commit('logoutAsTeacher')
      this.$router.push('/teacher/top')
      this.$emit('changeUserState')
    }
  },
}
</script>

